/**
 * Speech-bubble map pin icons for local notes.
 */

import Icon from 'ol/style/Icon.js';
import Style from 'ol/style/Style.js';

/**
 * @param {string} value
 */
function escapeSvgText(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/**
 * @param {{ selected?: boolean, label?: string }} options
 */
export function pinBubbleSvg({ selected = false, label = '' } = {}) {
    const stroke = selected ? '#ffdd00' : '#ffffff';
    const strokeWidth = selected ? 2.8 : 2;
    const fill = selected ? '#6a2fb0' : '#7B3CC7';
    const display = label
        ? escapeSvgText(label.length > 7 ? `${label.slice(0, 6)}…` : label)
        : '•';

    return `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="48" viewBox="0 0 40 48">
        <path d="M6 4h28a5 5 0 0 1 5 5v18a5 5 0 0 1-5 5H18l-8 12v-12H6a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5z"
            fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-linejoin="round"/>
        <text x="20" y="21" text-anchor="middle" dominant-baseline="middle"
            fill="#ffffff" font-size="10" font-family="system-ui, sans-serif" font-weight="700">${display}</text>
    </svg>`;
}

/**
 * @param {{ selected?: boolean, label?: string }} options
 */
export function pinBubbleIconUrl(options = {}) {
    return `data:image/svg+xml,${encodeURIComponent(pinBubbleSvg(options))}`;
}

/**
 * @param {import('ol/Feature').default} feature
 * @param {string|null} openPinId
 */
export function styleForMapPin(feature, openPinId) {
    const selected = feature.get('pinId') === openPinId;
    const note = String(feature.get('pinNote') || '').trim();

    return new Style({
        image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: pinBubbleIconUrl({ selected, label: note }),
            scale: selected ? 1.12 : 1,
        }),
        zIndex: selected ? 45 : 42,
    });
}
